export default {
  suppressions: {
    data: [],
    meta: {}
  }
}
